import React, { useCallback, useLayoutEffect, useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import Animated, { useAnimatedRef, useSharedValue, useDerivedValue, useAnimatedScrollHandler, runOnJS, } from 'react-native-reanimated';
import Button from 'design-system/Button';
import StatusBar from 'design-system/StatusBar';
import { AppView } from 'design-system/AppView';
import useColors from 'hooks/useColors';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { triggerSelectorPress } from 'utils/hapticFeedback';
import PendingStockAlerts from '../components/PendingStockAlerts';
import StockAlertScreenHeader from '../components/StockAlertScreenHeader';
import TriggeredStockAlerts from '../components/TriggeredStockAlerts';
import { isWeb } from '../../../constants';
const StockAlertScreen = ({ route, navigation }) => {
    const scrollX = useSharedValue(0);
    const scrollYPending = useSharedValue(0);
    const scrollYTriggered = useSharedValue(0);
    const isUserScrolling = useSharedValue(false);
    const colors = useColors();
    const horizontalScrollViewRef = useAnimatedRef();
    const { assetId } = route.params || {};
    useLayoutEffect(() => {
        navigation.setOptions({
            headerTintColor: colors.text.primary,
        });
    }, [colors.text.primary]);
    const { width, deviceWidth: screenWidth } = useAppFrameDimensions(isWeb);
    const scrollViewStyles = useMemo(() => ({
        width: 2 * screenWidth,
    }), [screenWidth]);
    const scrollY = useDerivedValue(() => {
        if (scrollX.value > width / 2) {
            return scrollYTriggered.value;
        }
        return scrollYPending.value;
    }, [width]);
    const scrollXHandler = useAnimatedScrollHandler({
        onBeginDrag: () => {
            isUserScrolling.value = true;
        },
        onScroll: ({ contentOffset }) => {
            scrollX.value = contentOffset.x;
        },
        onMomentumEnd: () => {
            if (isUserScrolling.value) {
                runOnJS(triggerSelectorPress)();
            }
            isUserScrolling.value = false;
        },
    });
    const handleCreateAlert = useCallback(() => {
        if (assetId) {
            navigation.navigateDeprecated('InvestSetStockAlertScreen', {
                assetId,
            });
            return;
        }
        navigation.navigateDeprecated('InvestSearchStock', { stockAlertFlow: true });
    }, [assetId]);
    return (<AppView withFrame={false}>
      <StatusBar barStyle="dark-content" animated/>
      <StockAlertScreenHeader scrollX={scrollX} scrollY={scrollY} horizontalScrollViewRef={horizontalScrollViewRef}/>
      <View style={styles.container}>
        <Animated.ScrollView horizontal pagingEnabled scrollEventThrottle={16} onScroll={scrollXHandler} ref={horizontalScrollViewRef} showsHorizontalScrollIndicator={false} contentContainerStyle={[scrollViewStyles]}>
          <View style={[styles.flex, { width: screenWidth }]}>
            <PendingStockAlerts scrollY={scrollYPending} assetId={route.params?.assetId}/>
          </View>
          <View style={[styles.flex, { width: screenWidth }]}>
            <TriggeredStockAlerts scrollY={scrollYTriggered} assetId={route.params?.assetId}/>
          </View>
        </Animated.ScrollView>
      </View>
      <Button brand floating title="Create alert" onPress={handleCreateAlert}/>
    </AppView>);
};
const styles = StyleSheet.create({
    container: {
        flex: 1,
    },
    flex: {
        flex: 1,
    },
});
export default StockAlertScreen;
